export const GET_NOMENCLATURES_IN_PROGRESS = "GET_NOMENCLATURES_IN_PROGRESS";
export const GET_NOMENCLATURES_SUCCESS = "GET_NOMENCLATURES_SUCCESS";
export const GET_NOMENCLATURES_FAIL = "GET_NOMENCLATURES_FAIL";
